import React from 'react';
import './InternetPlans.css';

const PlanCard = ({ speed, description, price, buttonColor, borderColor }) => {
  // Función para manejar el clic y redirigir a WhatsApp
  const handleWhatsappClick = () => {
    const whatsappMessage = `Hola, estoy interesado en el plan de FibraLink de ${speed} Mbps por $${price}.`;
    const whatsappLink = `https://wa.me/593990441331?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="plan-card-wrapper">
      <div className={`plan-card-border plan-card-border-${borderColor}`}></div>
      <div className={`plan-card plan-card-${speed}`}>
        <div className="card-content">
          <h2 className="speed">{speed} Mbps</h2>
          <p className="fiber-info">100% fibra óptica</p>
          <div className="divider"></div>
          <p className="description">{description}</p>
          <div className="container-price">
            <span className="price">${price}</span>
            <p className="tax-info">iva incluido</p>
          </div>
        </div>
        {/* Botón que llama a WhatsApp */}
        <button
          className={`plan-button plan-button-${buttonColor}`}
          onClick={handleWhatsappClick}
        >
          Quiero este plan
        </button>
      </div>
    </div>
  );
};

const InternetPlans = () => {
  return (
    <div className="plans-container">
      <PlanCard
        speed="300"
        description="Ideal para el hogar y pequeños negocios."
        price="20.00"
        buttonColor="300"
        borderColor="orange"
      />
      <PlanCard
        speed="500"
        description="Perfecto para streaming, gaming y teletrabajo."
        price="25.00"
        buttonColor="500"
        borderColor="blue"
      />
    </div>
  );
};

export default InternetPlans;
